<template>
  <!-- <div class="install-bonus-popup-wrap" v-if="deferredPrompt && userInfo.openid"> -->
  <div class="install-bonus-popup-wrap">
    <div class="ib-popup" :class="{ 'active': !isMinimize && active }">
      <div class="ib-content">
        <p class="title"><span>{{ $t('title_install_bonus') }}</span></p>
        <p class="subtitle">{{ $t('subtitle_install_bonus') }}</p>
        <div class="award-list">
          <div class="item" v-for="item in 5" :key="item" :class="`item-${item}`"></div>
        </div>
        <div class="tips" v-html="$t('tips_install_bonus', [`<span>${$t('title_install_bonus')}</span>`])"></div>
      </div>
      <a href="javascript:;" class="btn-install" @click="install"><span>{{ $t('title_install_bonus') }}</span></a>
      <a href="javascript:;" class="btn-close" @click="minimize"></a>
    </div>
    <div class="ib-popup-s" :class="{ 'active': isMinimize }" @click="isMinimize = false">
      <div class="view"></div>
      <p class="text">{{ $t('btn_receive_award') }}</p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InstallBonus',
  props: {
    showType: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      deferredPrompt: window.__deferredPrompt || undefined,
      active: false,
      isMinimize: false
    }
  },
  created () {
    setTimeout(() => {
      this.active = true
    }, 10)
    this.isMinimize = this.showType === 'default'
    this.$utils.log('webgame_shorcut_guide', { type: 'pop_up_window' })
  },
  computed: {
    ...mapState({
      userInfo: 'userInfo'
    })
  },
  methods: {
    install () {
      this.$emit('pwaInstall')
      this.close()
    },
    // 最小化
    minimize () {
      this.isMinimize = true
    },
    close () {
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
.install-bonus-popup-wrap{
  // width: 100%;
  // height: 100%;
  // position: absolute;
  // top: 0;
  // left: 0;
  // display: flex;
  // align-items: center;
  // justify-content: center;
}
.ib-popup-s{
  width: 128px;
  height: 128px;
  transition: all 0.3s;
  position: fixed;
  top: 50%;
  right: -150px;
  background: url(~@/assets/img/bg_ib_popup_s.png) no-repeat center center;
  background-size: contain;
  &.active{
    right: 14px;
  }
  .view{
    width: 96px;
    height: 76px;
    margin: 0 auto;
    position: relative;
    top: 28px;
    background: url(~@/assets/img/view_ib_popup_s.png) no-repeat center center;
    background-size: contain;
    animation: ibPopupSView 1s linear infinite;
  }
  .text{
    min-width: 130px;
    padding: 0 5px;
    text-align: center;
    font-size: 18px;
    color: #fff;
    white-space: nowrap;
    position: absolute;
    font-weight: 500;
    left: 50%;
    transform: translateX(-50%);
    top: 90px;
    line-height: 40px;
    background: url(~@/assets/img/txt_bg.png) no-repeat center center;
    text-shadow: 0px 2px 2px #000000;
  }
}
@keyframes ibPopupSView {
  0% {
    transform: scale(1);
  }
  30% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.ib-popup{
  width: 1210px;
  height: 644px;
  opacity: 0;
  margin-top: -13px;
  transition: opacity .3s;
  position: fixed;
  top: 50%;
  left: 200%;
  transform: translate(-50%, -50%) scale(.75);
  background: url(~@/assets/img/bg_ib_popup.png) no-repeat right bottom;
  background-size: contain;
  &.active{
    opacity: 1;
    left: 50%;
  }
  .btn-install{
    width: 520px;
    height: 102px;
    padding-left: 32px;
    position: absolute;
    right: -23px;
    bottom: -10px;
    font-size: 38px;
    color: #1E1411;
    text-align: center;
    line-height: 102px;
    font-weight: 600;
    background: url(~@/assets/img/btn_install_ib_popup.png) no-repeat center center;
    background-size: contain;
    animation: btnInstall 1s linear infinite;
    span{
      padding-right: 35px;
      background: url(~@/assets/img/style_ib_popup.png) no-repeat center right;
      background-size: 25px 20px;
    }
  }
  .btn-close{
    width: 61px;
    height: 60px;
    position: absolute;
    top: 115px;
    right: 15px;
    background: url(~@/assets/img/close_ib_popup.png) no-repeat center center;
    background-size: contain;
  }
}
@keyframes btnInstall {
  0% {
    transform: scale(1);
  }
  60% {
    transform: scale(.95);
  }
  100% {
    transform: scale(1);
  }
}
.ib-content{
  width: 490px;
  position: absolute;
  top: 170px;
  right: 0px;
  .title{
    height: 62px;
    line-height: 62px;
    margin-bottom: 24px;
    font-size: 50px;
    text-align: center;
    color: #FCF163;
    font-weight: 600;
    text-shadow: 0px 1px 1px #000000;
    position: relative;
    span{
      width: 100%;
      font-size: 54px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
  .subtitle{
    height: 40px;
    line-height: 40px;
    margin-bottom: 34px;
    font-size: 32px;
    text-align: center;
    color: #FCF163;
    font-weight: 600;
    text-shadow: 0px 1px 1px #000000;
  }
}
.award-list{
  width: 100%;
  height: 124px;
  margin-bottom: 8px;
  white-space: nowrap;
  position: relative;
  left: -50px;
  .item{
    width: 122px;
    height: 123px;
    margin-left: -14px;
    display: inline-block;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: contain;
    &.item-1{ background-image: url(~@/assets/img/ib-award-1.png); }
    &.item-2{ background-image: url(~@/assets/img/ib-award-2.png); }
    &.item-3{ background-image: url(~@/assets/img/ib-award-3.png); }
    &.item-4{ background-image: url(~@/assets/img/ib-award-4.png); }
    &.item-5{ background-image: url(~@/assets/img/ib-award-5.png); }
  }
}
.tips{
  width: 420px;
  min-height: 38px;
  padding-top: 4px;
  margin: 0 auto;
  text-align: center;
  line-height: 30px;
  font-size: 22px;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.4);
  ::v-deep(span){
    color: #DA5308;
  }
}
</style>
